import { setAriaProp } from "@common/utilities.js";
import { emitVideoPauseEvent } from "@components/video-thumbs/video-thumbs.js";

export default class RegistrationsForm {
	constructor(config) {
		this.el = config.el;
		this.viewMoreButtonEl = this.el.querySelector(".js-intro-box-btn");
		this.contentEl = this.el.querySelector(".js-intro-box-content");
		this.contentRTE = this.el.querySelector(".js-intro-box-richtext");

		this.btnExpandLabel = this.viewMoreButtonEl.dataset.expandLabel;
		this.btnCollapseLabel = this.viewMoreButtonEl.dataset.collapseLabel;
		this.btnExpandClass = "btn--plus";
		this.btnCollapseClass = "btn--minus";
		this.expanded = false;

		this.expandToggleClass = "intro-box--expanded";

		this.init();
	}

	init() {
		this.attachEvents();
	}

	attachEvents() {
		this.viewMoreButtonEl.addEventListener("click", (e) => {
			this.expanded = !this.expanded;

			if (this.expanded) {
				this.expand();
			} else {
				this.collapse();
			}
		});

		this.contentEl.addEventListener("transitionend", (e) => {
			if (e.propertyName === "height") {
				// remove fixes height once accordion animation is done
				this.contentEl.style.height = this.expanded ? "auto" : "";
			}
		});
	}

	expand() {
		this.expanded = true;
		this.viewMoreButtonEl.classList.add(this.btnCollapseClass);
		this.viewMoreButtonEl.classList.remove(this.btnExpandClass);
		this.viewMoreButtonEl.textContent = this.btnCollapseLabel;
		this.el.classList.add(this.expandToggleClass);
		setAriaProp(this.contentEl, "expanded", true);
		this.contentRTE?.removeAttribute("inert");

		// animate accordion style
		this.contentEl.style.height = this.contentEl.scrollHeight + "px";
	}

	collapse() {
		this.expanded = false;
		emitVideoPauseEvent(this.el);
		this.viewMoreButtonEl.classList.add(this.btnExpandClass);
		this.viewMoreButtonEl.classList.remove(this.btnCollapseClass);
		this.viewMoreButtonEl.textContent = this.btnExpandLabel;
		this.el.classList.remove(this.expandToggleClass);
		setAriaProp(this.contentEl, "expanded", false);
		this.contentRTE?.setAttribute("inert", "");

		// animate accordion style
		this.contentEl.style.height = this.contentEl.scrollHeight + "px";
		requestAnimationFrame(() => {
			this.contentEl.style.height = "";
		});
	}
}
